<template>
    <div>
        <b-row>
            <b-col md="6">
                <CCard>
                    <CCardHeader color="primario" text-color="white">
                        <i class="fas fa-chart-bar"></i> <span class="h5"> Estadísticas</span>
                    </CCardHeader>
                    <CCardBody>
                        <span class="h6 text-muted">ESTADÍSTICAS DEL SISTEMA PARA EL TREKKING:
                        </span>
                        <hr>
                        <b-row class="justify-content-center text-center">
                            <b-col cols="12" class=" my-2 icon-custom">
                                <i style="inline-size: auto" class="ico fas fa-check-double fa-3x pb-1"></i>
                                <br>
                                <span class="lg-numero">{{listTrekking.length}}</span>
                                <br>
                                <span class="text-muted">Trekking Registrados</span>
                            </b-col>
                        </b-row>
                    </CCardBody>
                </CCard>
            </b-col>

            <b-col md="6">
                <CCard>
                    <CCardHeader color="primario" text-color="white">
                        <i class="fas fa-cog"></i><span class="h5"> Trekking</span>
                    </CCardHeader>
                    <CCardBody>
                        <b-row class="justify-content-center text-center">
                            <b-col cols="6" class="my-2">
                                <b-button block variant="custom" @click="modalRegTrekking = true">
                                    <i style="inline-size: auto" class="fas fa-plus-circle fa-3x pb-1"></i><br><span>Nuevo Trekking</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </CCardBody>
                </CCard>
            </b-col>

            <b-col md="12">
                <CCard>
                    <CCardHeader color="primario" text-color="white">
                        <i class="fas fa-list fa-md"></i><span class="h5"> Listado de Trekking Registrados </span>
                        <b-button v-if="listTrekking.length >= 1" class="float-right" variant="success" size="sm" @click="exportDataToExcel">
                        <i class="fas fa-download mr-1"></i>
                        Exportar</b-button>
                    </CCardHeader>
                    <CCardBody>
                        <b-row>
                            <b-col md="3">
                                <b-form-group label="Registros por página" class="text-muted">
                                    <b-form-select size="xl" v-model="porPagina" :options="paginaOpciones"></b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                            </b-col>
                            <b-col md="3">
                                <b-form-group label="Busqueda:" class="text-muted">
                                    <b-input-group size="xl">
                                        <b-input-group-prepend is-text>
                                            <i class="fas fa-search my-0 mx-0"></i>
                                        </b-input-group-prepend>
                                        <b-form-input type="search" v-model="filter" id="filterInput" placeholder="Buscar..."></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col md="12">
                                <b-table bordered hover show-empty mediun responsive outlined :items="listTrekking" :fields="camposTrekking" :current-page="paginaActual" :per-page="porPagina" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" empty-text="Aún no hay datos en esta sección." empty-filtered-text="No hay datos que coincidan con tu busqueda.">
                                    <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                                    <template v-slot:cell(nombreGuia)="data">
                                        <template v-if="listUsuarios.find(x => x.idGuia == data.item.idGuia) == null">
                                            {{''}}
                                        </template>
                                        <template v-else>
                                            {{listUsuarios.find(x => x.idGuia == data.item.idGuia).nombre | truncate(50)}}
                                        </template>
                                    </template>
                                    <template v-slot:cell(nombreTrekking)="data">
                                        {{data.item.nombreTrekking | truncate(30)}}
                                    </template>
                                    <template v-slot:cell(check)="data">
                                        <i v-if="data.item.evaluacion == 0" class="fas fa-question-circle"></i>
                                        <i v-if="data.item.evaluacion == 1" class="fas fa-check-circle"></i>
                                        <i v-if="data.item.evaluacion == 2" class="fas fa-times-circle"></i>
                                    </template>
                                    <template v-slot:cell(observacion)="data">
                                        {{data.item.observacion | truncate(30)}}
                                    </template>
                                    <template v-slot:cell(opciones)="param">
                                        <b-button size="sm" v-c-tooltip.hover.click="'Ver detalles'" @click="abrirModalActTrekking(param)" variant="dark" class=" mr-1 mb-1">
                                            <span class="btn-inner--icon">
                                                <i class="fas fa-search my-0 mx-0"></i>
                                            </span>
                                        </b-button>
                                        <b-button size="sm" class="mr-1 mb-1" v-c-tooltip.hover.click="'Eliminar'" @click="elimiarTrekking(param)" variant="danger">
                                            <span class="btn-inner--icon">
                                                <i class="fas fa-trash-alt  my-0 mx-0"></i>
                                            </span>
                                        </b-button>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </CCardBody>
                    <CCardFooter>
                        <b-pagination size="sm" v-model="paginaActual" :total-rows="filasTotales" :per-page="porPagina" first-number last-number align="right" class="my-0"></b-pagination>
                    </CCardfooter>
                </CCard>
            </b-col>
        </b-row>

        <CModal :show.sync="modalRegTrekking" size="xl" color="primario" :closeOnBackdrop="false">
            <template #header>
                <h6 class="modal-title">
                    <i class="fas fa-plus-square fa-md"></i>
                    <span class="h5"> Nuevo Registro de Trekking</span>
                </h6>
                <CButtonClose @click="modalRegTrekking = false" class="text-white" />
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(registrarTrekking)">
                    <b-row>
                        <b-col md="12">
                            <validation-provider name="guia principal" rules="required" v-slot="{errors}">
                                <b-form-group label="Guia Principal:" class="mb-2">
                                    <!-- <v-select :reduce="listDocumentos => listDocumentos.idDocumento" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosGuia.idTipoDocumento , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosGuia.idTipoDocumento" :options="listDocumentos"> -->
                                    <v-select :reduce="listUsuarios => listUsuarios.idGuia" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosRegTrekking.idGuia , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosRegTrekking.idGuia" :options="listUsuarios" @search:blur="blurTrekking">
                                        <span slot="no-options" class="text-muted">Busqueda no encontrada</span>
                                    </v-select>
                                    <div class="invalid-feedback">{{ errors[0]}}</div>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="9">
                            <validation-provider name="nombre del trekking" :rules="{required: true}" v-slot="validationContext">
                                <b-form-group label="Nombre del Trekking:" class="mb-2">
                                    <b-form-input  :state="getValidationState(validationContext)" placeholder="Ingrese el Nombre del Trekking" v-model.trim="datosRegTrekking.nombreTrekking"></b-form-input>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="3">
                            <validation-provider name="uso" :rules="{required: false}" v-slot="validationContext">
                                <b-form-group label="Uso:" class="mb-2">
                                    <b-form-radio-group v-model.trim="datosRegTrekking.evaluacion" plain :options="comboSiNo"></b-form-radio-group>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="12">
                            <validation-provider name="observacion" :rules="{required: false}" v-slot="validationContext">
                                <b-form-group label="Observación(Opcional):" class="mb-2">
                                    <b-form-textarea v-model="datosRegTrekking.observacion" :state="getValidationState(validationContext)" placeholder="Ingrese la Observación" rows="3" max-rows="6"></b-form-textarea>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="12" class="text-right my-2">
                            <b-button :disabled="disabled" variant="success" class=" mr-2" type="submit">
                                Guardar
                            </b-button>
                            <b-button variant="danger" @click="modalRegTrekking = false">
                                Cancelar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </CModal>

        <CModal :show.sync="modalActTrekking" size="xl" color="primario" :closeOnBackdrop="false">
            <template #header>
                <h6 class="modal-title">
                    <i class="fas fa-plus-square fa-md"></i>
                    <span class="h5"> Actualizar Trekking</span>
                </h6>
                <CButtonClose @click="modalActTrekking = false" class="text-white" />
            </template>
            <validation-observer ref="observer1" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(actualizarTrekking)">
                    <b-row>
                        <b-col md="12">
                            <validation-provider name="guia principal" rules="required" v-slot="{errors}">
                                <b-form-group label="Guia Principal:" class="mb-2">
                                    <!-- <v-select :reduce="listDocumentos => listDocumentos.idDocumento" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosGuia.idTipoDocumento , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosGuia.idTipoDocumento" :options="listDocumentos"> -->
                                    <v-select :reduce="listUsuarios => listUsuarios.idGuia" label="nombre" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosActTrekking.idGuia , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosActTrekking.idGuia" :options="listUsuarios" @search:blur="blurActTrekking">
                                        <span slot="no-options" class="text-muted">Busqueda no encontrada</span>
                                    </v-select>
                                    <div class="invalid-feedback">{{ errors[0]}}</div>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="9">
                            <validation-provider name="nombre del trekking" :rules="{required: true}" v-slot="validationContext">
                                <b-form-group label="Nombre del Trekking:" class="mb-2">
                                    <b-form-input  :state="getValidationState(validationContext)" placeholder="Ingrese el Nombre del Trekking" v-model.trim="datosActTrekking.nombreTrekking"></b-form-input>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="3">
                            <validation-provider name="uso" :rules="{required: false}" v-slot="validationContext">
                                <b-form-group label="Uso:" class="mb-2">
                                    <b-form-radio-group v-model.trim="datosActTrekking.evaluacion" plain :options="comboSiNo"></b-form-radio-group>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="12">
                            <validation-provider name="observacion" :rules="{required: false}" v-slot="validationContext">
                                <b-form-group label="Observación:" class="mb-2">
                                    <b-form-textarea v-model="datosActTrekking.observacion" :state="getValidationState(validationContext)" placeholder="Ingrese la Observación" rows="3" max-rows="6"></b-form-textarea>
                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="12" class="text-right my-2">
                            <b-button :disabled="disabled" variant="success" class=" mr-2" type="submit">
                                Actualizar
                            </b-button>
                            <b-button variant="danger" @click="modalActTrekking = false">
                                Cancelar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </CModal>
    </div>
</template>

<script>
// PARA LOS ICONOS SE USO V5 => https://fontawesome.com/v5/icons/question-circle?s=solid
import firebase from 'firebase';
const dbUsuario = firebase.firestore().collection('users');
const dbTrekking = firebase.firestore().collection('trekking');
import XLSX from 'sheetjs-style-v2';

export default {
    data() {
        return {
            listTrekking: [],
            listUsuarios: [],
            disabled: false,

            filasTotales: 1,
            paginaActual: 1,
            porPagina: 10,
            paginaOpciones: [
                10, 25, 50, 100, 
                {
                    value: 9999999,
                    text: "Mostrar todos"
                }
            ],
            filter: null,
            filterOn: [],

            camposTrekking: [
                {
                    key: "index",
                    label: "N°",
                    class: "text-center",
                },
                {
                    key: "nombreGuia",
                    label: "Guia Principal",
                    class: "text-center",
                },
                {
                    key: "nombreTrekking",
                    label: "Nombre del Trekking",
                    class: "text-center",
                },
                {
                    key: "check",
                    label: "Uso",
                    class: "text-center",
                },
                {
                    key: "observacion",
                    label: "Observación",
                    class: "text-center",
                },
                {
                    key: "opciones",
                    label: "",
                    class: "text-center",
                },
            ],

            datosRegTrekking: {
                idGuia: '',
                nombreTrekking: '',
                evaluacion: 0,
                observacion: '',
            },

            datosActTrekking: {
                id: '',
                idGuia: '',
                nombreTrekking: '',
                evaluacion: 0,
                observacion: '',
            },

            comboSiNo: [
                {
                    value: 1,
                    text: 'Si',
                },
                {
                    value: 2    ,
                    text: 'No',
                },
            ],

            modalRegTrekking: false,
            modalActTrekking: false,
        }
    },
    methods: {
        exportDataToExcel() {
            let now = moment().format('YYYYMMDDHHmm');

            const valUpper = text => {
                if (text != null && text !== undefined) {
                    return text.toString().toUpperCase();
                }
                return '';
            };

            const valDate = date => {
                if (date && date !== undefined) {
                    return moment(date).format('DD-MM-YYYY')
                }
                return '';
            };

            let dataExcel = this.listTrekking.map(data => {
                return {
                    A: valUpper(this.listUsuarios && this.listUsuarios !== undefined ?
                        this.listUsuarios.filter(x => x.idGuia == data.idGuia).length > 0 ?
                        this.listUsuarios.filter(x => x.idGuia == data.idGuia)[0].nombre : '' : ''),
                    B: valUpper(data['nombreTrekking']),
                    C: data['evaluacion'] == 1 ? 'SI' : data['evaluacion'] == 2 ? 'NO' : '',
                    D: valUpper(data['observacion']),
                };
            });

            let dataWS = XLSX.utils.json_to_sheet(dataExcel, {
                origin: 'A4',
            });

            let dataWSMerges = [{
                s: {
                    r: 1,
                    c: 1,
                },
                e: {
                    r: 1,
                    c: 3,
                },
            }];

            dataWS['!merges'] = dataWSMerges;

            let dataWSCols = [
                {
                    wch: 30, //A
                },
                {
                    wch: 30, //B
                },
                {
                    wch: 15, //C
                },
                {
                    wch: 50, //D
                },
            ];

            dataWS['!cols'] = dataWSCols;

            for(let i of [
                {
                    f: 'B2',
                    v: 'TREKKING',
                },
                {
                    f: 'C2',
                },
                {
                    f: 'D2',
                },
                {
                    f: 'A4',
                    v: 'NOMBRE DE GUÍA',
                },
                {
                    f: 'B4',
                    v: 'NOMBRE DEL TREKKING',
                },
                {
                    f: 'C4',
                    v: 'USO',
                },
                {
                    f: 'D4',
                    v: 'OBSERVACIÓN',
                },
            ]){
                XLSX.utils.sheet_add_aoa(dataWS, [
                    [i.v || '']
                ], {
                    origin: i.f,
                });

                dataWS[i.f].s = {
                    numFmt: i.w || 'general',
                    fill: {
                        fgColor: {
                            rgb: i.b ? 'FFFFFF' : 'F2F2F2',
                        },
                    },
                    font: {
                        name: 'arial',
                        sz: 8,
                        bold: i.b ? false : true,
                        color: {
                            rgb: i.b ? '000000' : '1F497D',
                        },
                    },
                    border: {
                        top: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                        bottom: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                        right: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                        left: {
                            style: 'thin',
                            color: {
                                rgb: 'A6A6A6',
                            },
                        },
                    },
                    alignment: {
                        horizontal: 'center',
                        vertical: 'center',
                        wrapText: 1,
                    },
                };
            }

            for (let k in dataExcel) {
                for (let i of Object.keys(dataExcel[0])) {
                    dataWS[`${i}${(parseInt(k) + 5).toString()}`].s = {
                        numFmt: '@',
                        fill: {
                            fgColor: {
                                rgb: 'FFFFFF',
                            },
                        },
                        font: {
                            name: 'arial',
                            sz: 8,
                            color: {
                                rgb: '000000',
                            },
                        },
                        border: {
                            top: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                            bottom: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                            right: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                            left: {
                                style: 'thin',
                                color: {
                                    rgb: 'A6A6A6',
                                },
                            },
                        },
                        alignment: {
                            horizontal: 'center',
                            vertical: 'center',
                        },
                    };
                }
            }

            let wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, dataWS, 'TREKKING');
            XLSX.writeFile(wb, `TREKKING ${now}.xlsx`);
        },
        onFiltered(itemsFiltrados) {
            this.filasTotales = itemsFiltrados.length
            this.paginaActual = 1
        },
        getValidationState({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        blurTrekking() {
            this.computedForms.refs['guia principal'].validate();
        },
        blurActTrekking() {
            this.computedFormsAct.refs['guia principal'].validate();
        },
        listarUsuarios() {
            let me = this;

            dbUsuario
            .where("estado" , "==" , 2)
            .where("idCliente", "==", String(me.$store.state.user.idCliente))
            .where("rol","==","guia")
            .onSnapshot((querySnapshot) => {
                me.listUsuarios = [];
                querySnapshot.forEach((doc) => {
                    me.listUsuarios.push({
                        idGuia: doc.id,
                        nombre: doc.data().nombre + ' ' + doc.data().apellidoPaterno + ' ' + doc.data().apellidoMaterno,
                    });
                });
            });
        },
        registrarTrekking() {
            let me = this;

            me.disabled = true;
            dbTrekking.add({
                idGuia: me.datosRegTrekking.idGuia.trim(),
                nombreTrekking: me.datosRegTrekking.nombreTrekking.trim(),
                evaluacion: me.datosRegTrekking.evaluacion,
                observacion: me.datosRegTrekking.observacion.trim(),
                estado: 2,
                fechaCreacion: firebase.firestore.Timestamp.fromDate(new Date()),
                fechaModificacion: '',
                fechaEliminar: '',
                idCliente: me.$store.state.user.idCliente.trim(),
            }).then((doc) =>{
                me.swat('success', 'Registrado satisfactoriamente')
                me.modalRegTrekking = false;
                me.disabled = false;
            }).catch((error) => {
                me.disabled = false;
                me.swat('error', 'Algo salió mal!');
            });
        },
        listarTrekking() {
            let me = this;

            dbTrekking
            .where("estado","==", 2)
            .where("idCliente", "==", String(me.$store.state.user.idCliente))
            .onSnapshot((querySnapshot) => {
                me.listTrekking = [];
                querySnapshot.forEach((doc)=>{
                    me.listTrekking.push({
                        id: doc.id,
                        evaluacion: doc.data().evaluacion,
                        fechaCreacion: doc.data().fechaCreacion,
                        idGuia: doc.data().idGuia,
                        nombreTrekking: doc.data().nombreTrekking,
                        observacion: doc.data().observacion,
                    });
                });

                me.listTrekking.sort((a, b) => (a.fechaCreacion > b.fechaCreacion) ? -1 : ((b.fechaCreacion > a.fechaCreacion) ? 1 : 0));
            });
        },
        elimiarTrekking(param) {
            let me = this;

            me.$swal.fire({
                title: '¿Estas seguro de eliminar el Trekking?',
                text: "¡No podrás revertir esto!",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
            }).then((result) => {
                if (result.isConfirmed) {
                    dbTrekking.doc(param.item.id).update({
                        estado: 1,
                        fechaEliminar: firebase.firestore.Timestamp.fromDate(new Date()),
                    })
                    .then(() => {
                        me.swat('success', 'Eliminado satisfactoriamente')
                        me.disabled = false;
                    })
                    .catch((error) => {
                        me.disabled = false;
                        me.swat('error', 'Algo salió mal!')
                    });
                }
            });
        },
        actualizarTrekking() {
            let me = this;

            me.disabled = true;

            dbTrekking.doc(me.datosActTrekking.id).update({
                idGuia: me.datosActTrekking.idGuia.trim(),
                nombreTrekking: me.datosActTrekking.nombreTrekking.trim(),
                evaluacion: me.datosActTrekking.evaluacion,
                observacion: me.datosActTrekking.observacion.trim(),
                fechaModificacion: firebase.firestore.Timestamp.fromDate(new Date()),
            }).then((doc)=> {
                me.swat('success', 'Modificado satisfactoriamente');
                me.modalActTrekking = false;
                me.disabled = false;
            }).catch((error) => {
                me.disabled = false;
                me.swat('error', 'Algo salió mal!');
            });
        },
        abrirModalActTrekking(param) {
            let me = this;

            me.datosActTrekking.id = param.item.id;
            me.datosActTrekking.idGuia = param.item.idGuia;
            me.datosActTrekking.nombreTrekking = param.item.nombreTrekking.trim();
            me.datosActTrekking.evaluacion = param.item.evaluacion;
            me.datosActTrekking.observacion = param.item.observacion.trim();

            me.modalActTrekking = true;
        },
        swat(icon, title) {
            this.$swal.mixin({
                toast: true,
                showConfirmButton: false,
                position: 'bottom-right',
                timer: 3500,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            }).fire({
                icon: icon,
                title: title
            });
        },
        resetModalRegistrarTrekking () {
            this.$nextTick(() => {
                this.$refs.observer.reset();
            });

            this.datosRegTrekking.idGuia = '';
            this.datosRegTrekking.nombreTrekking = '';
            this.datosRegTrekking.evaluacion = 0;
            this.datosRegTrekking.observacion = '';
        },
        resetModalActualizarTrekking() {
            this.$nextTick(() => {
                this.$refs.observer1.reset();
            });

            this.datosActTrekking.id = '';
            this.datosActTrekking.idGuia = '';
            this.datosActTrekking.nombreTrekking = '';
            this.datosActTrekking.evaluacion = 0;
            this.datosActTrekking.observacion = '';
        },
    },
    computed: {
        computedForms() {
            return this.$refs.observer;
        },
        computedFormsAct() {
            return this.$refs.observer1;
        },
    },
    watch: {
        modalRegTrekking: function (val) {
            if (val == false) {
                this.resetModalRegistrarTrekking();
            }
        },
        modalActTrekking: function (val) {
            if (val == false) {
                this.resetModalActualizarTrekking();
            }
        },
    },
    mounted() {
        if (this.$store.state.user) {
            this.listarUsuarios();
            this.listarTrekking();
        }
    },
}
</script>